/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Badge_RuleInputs */

const en_directory_submit_badge_rule = /** @type {(inputs: Directory_Submit_Badge_RuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listings link out with`)
};

const zh_directory_submit_badge_rule = /** @type {(inputs: Directory_Submit_Badge_RuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`收录外链为`)
};

/**
* | output |
* | --- |
* | "Listings link out with" |
*
* @param {Directory_Submit_Badge_RuleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_badge_rule = /** @type {((inputs?: Directory_Submit_Badge_RuleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Badge_RuleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_badge_rule(inputs)
	return zh_directory_submit_badge_rule(inputs)
});
export { directory_submit_badge_rule as "directory.submit.badge.rule" }